/**
 * IndieAiPage — Full-page Indie AI chat
 *
 * Route: /clients/:client_code/indie-ai
 *
 * Replaces the previous MUI mock with the Figma-faithful IndieChatFull
 * component wired to the current client context and live Orbit streaming API.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import CurrentClientContext from '../../providers/CurrentClientProvider';
import { IndieChatFull } from '../../components/orbit';
import ClientFeatureFlagService from '../../services/ClientFeatureFlagService';

function IndieAi() {
  const location = useLocation();
  const currentClient = CurrentClientContext.useClient();
  const client = currentClient?.client || {};
  const initialConversationId = new URLSearchParams(location.search).get('conversation_id') || undefined;
  const isAiChatBotEnabled = ClientFeatureFlagService.isClientFeatureFlagEnabled(client);

  // client.Id is the integer PK used by Laravel Orbit routes
  const clientId = client?.Id ?? 0;
  if (client?.ClientCode && !isAiChatBotEnabled) {
    return <Navigate to={`/clients/${client.ClientCode}/profile`} replace />;
  }

  return (
    <IndieChatFull
      clientId={clientId}
      client={{ Name: client?.Name, ClientCode: client?.ClientCode }}
      initialConversationId={initialConversationId}
    />
  );
}

export default IndieAi;
